import { loadingPage } from "../common/_loadingPage";

export const pagesFunc = () => {
  // ローティングアニメーション
  loadingPage();
}
